export const UPCOMING_DATES = {
	CLOSURE_DATE: "CLOSURE_DATE",
	PAYMENT_DATE: "PAYMENT_DATE",
	AGM_DATE: "AGM_DATE",
};
